import { CallIntelligenceV2, CallIntelUtils } from '@frontend/api-call-intel';
import { useActiveFilters } from './use-active-filters';

const DEFAULT_CACHE_TIME = 5 * 60 * 1000; // 5 minutes

export const useTotalCallsAnalyzedCount = () => {
  const { filters } = useActiveFilters();

  const { data: totalCallsAnalyzed = 0, isLoading } = CallIntelligenceV2.Queries.useGetSchedulingAggregateStatsQuery({
    request: {
      ...CallIntelUtils.generateChartsPayload({ filters }),
    },
    options: {
      enabled: !!filters.locations?.length,
      retry: false,
      cacheTime: DEFAULT_CACHE_TIME,
      staleTime: DEFAULT_CACHE_TIME,
      select: (data) => data?.current?.totalCallsAnalyzed,
    },
  });

  return { totalCallsAnalyzed, isLoading };
};
